import { render } from "./Edit.vue?vue&type=template&id=64b59ef5"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=64b59ef5&lang=css"

import exportComponent from "/var/jenkins_home/workspace/aws.total-account-site.US/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__